import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const subscribeEmail = async ({ nama, email, sumber }) => {
  const res = await axios.post(`${API}/leads`, { name: nama, email, source: sumber || "langsung" });
  return res.data;
};
